import { render, staticRenderFns } from "./GenericCarousel.vue?vue&type=template&id=be565f7a&scoped=true&"
import script from "./GenericCarousel.vue?vue&type=script&lang=js&"
export * from "./GenericCarousel.vue?vue&type=script&lang=js&"
import style0 from "./GenericCarousel.vue?vue&type=style&index=0&id=be565f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be565f7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSlideGroup } from 'vuetify/lib/components/VSlideGroup';
import { VSlideItem } from 'vuetify/lib/components/VSlideGroup';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VProgressLinear,VSlideGroup,VSlideItem})
